export default {
  nav: {
    categories: 'Categorie',
    topSites: 'Siti migliori',
    compare: 'Confronta',
    submitSite: 'Invia sito',
    about: 'Chi siamo',
    logIn: 'Accedi',
  },
  common: {
    back: 'Indietro',
    search: 'Cerca',
    loading: 'Caricamento…',
    viewSimilarSites: 'Vedi siti simili',
  },
  hero: {
    badge: 'Motore di scoperta siti',
    titleA: 'Trova siti simili a',
    titleB: 'i tuoi preferiti.',
    titlePrefix: 'Trova siti simili a',
    titleAccent: 'i tuoi preferiti.',
    subtitle: 'Scopri concorrenti, alternative e gemme nascoste sul web con punteggi di similarità precisi.',
    placeholder: 'Inserisci un dominio (es. stripe.com)',
    inputPlaceholder: 'Inserisci un dominio (es. stripe.com)',
    step1Label: 'Inserisci un dominio',
    step1Desc: 'Digita un URL di un sito per iniziare',
    step2Label: 'Ottieni risultati',
    step2Desc: 'Il nostro motore trova siti simili all’istante',
    step3Label: 'Confronta e scegli',
    step3Desc: 'Analizza e confronta le alternative',
    steps: {
      step1Label: 'Inserisci un dominio',
      step1Desc: 'Digita un URL di un sito per iniziare',
      step2Label: 'Ottieni risultati',
      step2Desc: 'Il nostro motore trova siti simili all’istante',
      step3Label: 'Confronta e scegli',
      step3Desc: 'Analizza e confronta le alternative',
    },
  },
  footer: {
    newsletterTitle: 'Resta aggiornato',
    newsletterDesc: 'Ricevi report settimanali su siti in tendenza e nuove alternative.',
    emailPlaceholder: 'tu@email.com',
    subscribe: 'Iscriviti',
    brandDesc: 'Scopri le connessioni nascoste del web. Trova siti simili ai tuoi preferiti con un punteggio preciso.',
    explore: 'Esplora',
    popular: 'Popolari',
    company: 'Azienda',
    compareSites: 'Confronta siti',
    sitesLike: 'Siti come',
    contact: 'Contatti',
    faq: 'FAQ',
    removeYourSite: 'Rimuovi il tuo sito',
    privacyPolicy: 'Informativa sulla privacy',
    termsOfService: 'Termini di servizio',
    rights: 'Tutti i diritti riservati.',
  },
  notFound: {
    title: 'Ops! Pagina non trovata',
    returnHome: 'Torna alla home',
  },
  submitPage: {
    ctaTitle: 'Conosci un sito fantastico?',
    ctaDesc: 'Aiutaci a far crescere il database inviando i siti che ami. Bastano pochi secondi.',
    ctaButton: 'Invia sito',
    pageTitle: 'Invia un sito',
    pageSubtitle: 'Aiutaci inviando un sito web da indicizzare.',
    successTitle: 'Sito inviato!',
    successReviewPrefix: 'Esamineremo',
    successReviewSuffix: 'e lo aggiungeremo presto al nostro indice.',
    backHome: 'Torna alla home',
    domainLabel: 'Dominio *',
    domainPlaceholder: 'es. example.com',
    descriptionLabel: 'Descrizione',
    descriptionPlaceholder: 'Breve descrizione del sito',
    categoryLabel: 'Categoria',
    categorySelect: 'Seleziona una categoria',
    alternativeTo: 'Alternativa a (opzionale)',
    alternativeNone: 'Nessuna — non è un’alternativa',
    emailLabel: 'La tua email',
    emailPlaceholder: 'tu@esempio.com',
    submitButton: 'Invia sito',
    submitFailed: 'Invio non riuscito',
    seoTitle: 'Invia sito | CiteMatch',
    seoDesc: 'Invia un sito web per indicizzarlo su CiteMatch.',
  },
};

